import { SearchPageEvents } from '../../../analytics/search-action-cause.js';
export const getRangeFacetMetadata = (state, { facetId, selection }) => {
    const facet = state.dateFacetSet[facetId] || state.numericFacetSet[facetId];
    const facetField = facet.request.field;
    const facetTitle = `${facetField}_${facetId}`;
    return {
        facetId,
        facetField,
        facetTitle,
        facetRangeEndInclusive: selection.endInclusive,
        facetRangeEnd: `${selection.end}`,
        facetRangeStart: `${selection.start}`,
    };
};
export const rangeBreadcrumbFacet = () => ({
    actionCause: SearchPageEvents.breadcrumbFacet,
});
